import { Title } from '@angular/platform-browser';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { Router, ActivatedRoute } from '@angular/router';
import { TestCaseService } from '@app/testcase/testcase.service';
import { ToastrService } from 'ngx-toastr';
import { PerformanceService } from '../performance.service';
import { BusinessFlowFormComponent } from './business-flow-form/business-flow-form.component';
import { MetaDataFormComponent } from './meta-data-form/meta-data-form.component';
import { constants } from '@assets/data/constants';

@Component({
  selector: 'app-performance-test',
  templateUrl: './performance-test.component.html',
  styleUrls: ['./performance-test.component.less']
})
export class PerformanceTestComponent {

  // @ViewChild(MatHorizontalStepper, { static: true }) stepper: MatHorizontalStepper;
  // @ViewChild(BusinessFlowFormComponent, { static: false }) businessFlowForm: BusinessFlowFormComponent;
  // @ViewChild(MetaDataFormComponent, { static: false }) metaDataForm: MetaDataFormComponent;

  // // Stepper Attributes
  // isFirstStepComplete = false;
  // isFirstStepEditable = false;

  // rerun: any;
  // loadTestType: any;
  // perfLabValue: any;
  // impactedSystems = [];
  // performanceTestDetails = {};
  // parallelFlow = false;

  // constructor(private titleService: Title, private toastr: ToastrService, private performanceService: PerformanceService, private testCaseService: TestCaseService, private router: Router, private route: ActivatedRoute) { }

  // ngOnInit() {
  //   this.titleService.setTitle('Perf | Test');
  //   this.rerun = this.route.snapshot.queryParams.rerun;
  //   if (this.rerun && this.rerun !== undefined) {
  //     this.loadRerunData(this.rerun);
  //   }
  // }

  // loadRerunData(rerunId: any) {
  //   this.perfLabValue = {};
  //   this.performanceService.rerunQueue(rerunId).subscribe(data => {
  //     if (data.code === 200) {        
  //       this.perfLabValue = data.response;
  //       this.parallelFlow = data.response.parallelFlow;
  //       /* Set api type */
  //       this.loadTestType = data.response.testCase.loadTestType;
  //       this.perfLabValue.project = data.response.testCase.project;
  //       this.patchFormValues();
  //       this.businessFlowForm.listNonfunctionTestcase(this.perfLabValue.project, this.loadTestType);
  //       this.businessFlowForm.getLoadTestConfig(this.perfLabValue.testCase.id);
  //     } else {
  //       this.toastr.error(data.message);
  //       this.router.navigate(['/performance/loadTesting/queue']);
  //     }
  //   });
  // }

  // patchFormValues() {
  //   /* To complete first step */
  //   this.businessFlowForm.businessFlowForm.patchValue({
  //     loadTestType: this.loadTestType,
  //     perfLab: this.perfLabValue,
  //   });

  //   /* To enable second step */
  //   if (!this.businessFlowForm.disableNextBtn()) {
  //     this.isFirstStepComplete = true;
  //     this.isFirstStepEditable = true;
  //     this.stepper.selected.completed = true;
  //   }
  // }

  // goToPrevious() {
  //   this.stepper.previous();
  // }

  // businessFormCompleted(event) {
  //   this.isFirstStepComplete = event;
  //   this.isFirstStepEditable = event;
  //   if (event) {
  //     this.stepper.selected.completed = true;
  //     this.loadTestType = this.businessFlowForm.loadTestTypeValue;
  //     this.perfLabValue = this.businessFlowForm.perfLabValue;
  //     this.perfLabValue = { ...this.perfLabValue, parallelFlow: this.businessFlowForm.perfLabValue.loadTestConfig.parallelFlow };
  //     this.stepper.next();
  //   }
  // }

  // submitLoadTesting(loadTestData: any) {
  //   const perfLabData = Object.assign({}, loadTestData.perfLabValue);
  //   perfLabData.parallelFlow = loadTestData.perfLabValue.parallelFlow;
  //   perfLabData.loadTestConfig.parallelFlow = loadTestData.perfLabValue.parallelFlow;

  //   if (loadTestData.impactedSystems !== undefined) {
  //     this.impactedSystems = loadTestData.impactedSystems;
  //   }

  //   if (this.metaDataForm.durationTypeValue === constants.durationTypeCustom) {
  //     const startTime = (this.metaDataForm.startTimeValue &&
  //       this.metaDataForm.startTimeValue !== undefined) ? this.metaDataForm.startTimeValue : constants.defaultTimestamp;
  //     const time = this.formatDateTimeToString(this.metaDataForm.autoGoveranceStartDateValue, startTime);
  //     const splitedTime = time.split(':');
  //     perfLabData.startTime = splitedTime[0] + ':' + splitedTime[1] + ':00';
  //   } else {
  //     perfLabData.startTime = null;
  //   }

  //   if (perfLabData.emailStaus) {
  //     perfLabData.notifyByMail = true;
  //     perfLabData.additionalMail = perfLabData.emailId;
  //   }

  //   if (this.impactedSystems && this.impactedSystems.length > 0) {
  //     perfLabData.sharePointCalendarItem.approvalRequired = true;
  //     const impactedSystemsCopy = Object.assign(this.impactedSystems);
  //     const impactedSystemsNew = [];
  //     impactedSystemsCopy.forEach(impactedSys => {
  //       if (impactedSys.selected) {
  //         impactedSystemsNew.push({
  //           name: impactedSys.name,
  //           email: impactedSys.email
  //         });
  //       }
  //     });
  //     perfLabData.sharePointCalendarItem.impactedSystems = impactedSystemsNew;

  //     if (perfLabData.sharePointCalendarItem.impactedSystemOthers) {
  //       if (perfLabData.sharePointCalendarItem.impactedSystemOthers.selected) {
  //         perfLabData.sharePointCalendarItem.impactedSystems.push({
  //           name: perfLabData.impactedSystemOthers.name,
  //           email: perfLabData.impactedSystemOthers.email
  //         });
  //         delete perfLabData.sharePointCalendarItem.impactedSystemOthers;
  //       }
  //     }
  //   }

  //   delete perfLabData.emailStaus;
  //   delete perfLabData.email;
  //   delete perfLabData.project;
  //   delete perfLabData.entityName;

  //   this.updateLoadSetting(perfLabData.testCase.id, perfLabData.loadTestConfig).then(result => {
  //     perfLabData.loadTestSettings = null;
  //     this.performanceService.saveLoadTesting(perfLabData).subscribe(data => {
  //       if (data.code === 200) {
  //         this.toastr.success(data.message);
  //         this.router.navigate(['/performance/loadTesting/queue']);
  //       } else {
  //         this.toastr.error(data.message);
  //       }
  //     });
  //   }).catch(errMsg => this.toastr.error(errMsg));
  // }

  // formatDateTimeToString(dateTime: any, timeStamp: any) {
  //   const month = dateTime.month > 9 ? dateTime.month : '0' + dateTime.month;
  //   const selectedTime = timeStamp.hour + ':' + timeStamp.minute + ':' + timeStamp.second;
  //   return (dateTime.year + '-' + month + '-' + dateTime.day + ' ').concat(selectedTime);
  // }

  // updateLoadSetting(testCaseId, loadTestConfig) {
  //   this.toastr.info(constants.loadSettingUpdatedInfo);
  //   return new Promise((resolve, reject) => {
  //     this.testCaseService.updateLoadConfiguration(testCaseId, loadTestConfig).subscribe(data => {
  //       if (data.code === 200) {
  //         this.toastr.info(constants.configUpdatedSuccessfullyInfo);
  //         resolve(constants.configUpdatedSuccessfullyInfo);
  //       } else {
  //         reject(data.message);
  //       }
  //     });
  //   });
  // }
}
